<script lang="ts">
    import type {AxiosInstance} from 'axios';

    import {dyData, modal} from 'general/store';
    import {TEMPLATE} from 'general/constants';

    import Description from 'general/components/description/Description.svelte';
    import Form from 'general/components/form/sms/Form.svelte';
    import Policy from 'general/components/policy/Policy.svelte';
    import ActionButton from 'general/components/actionButton/ActionButton.svelte';
    import Logo from 'general/components/logo/Logo.svelte';
    import ScrollItem from 'general/components/scrollItem/ScrollItem.svelte';

    import s from './style.module.css';

    export let instance: AxiosInstance;
</script>

<ScrollItem>
    <div class={s.main} style="margin-top: {$dyData.side.sms?.marginTop || 0}">
        <Logo side="sms" />
        <Description template={TEMPLATE.SQUARE} value={$dyData.description?.sms} />
        <Form {instance} template={TEMPLATE.SQUARE}>
            <Policy side="sms" />
        </Form>
        <ActionButton
            handleClick={modal.close}
            marginTop={$dyData?.actionButton?.sms?.marginTop || '14px'}
            marginBottom={$dyData?.actionButton?.sms?.marginBottom || '20px'}
            fontSize={$dyData?.actionButton?.sms?.fontSize || '16px'}
            children={$dyData?.actionButton?.sms?.children || 'No thanks, remind me later.'}
            color="gray"
            template={TEMPLATE.SQUARE}
        />
    </div>
</ScrollItem>
